import { RouteRecordRaw } from "vue-router"
import { ScreenRouteNameEnum } from "@/shared/enums/routes/screen.enum.ts"
import { AppPermissions } from "@/shared/permissions"

export const screensRoutes: RouteRecordRaw[] = [
	{
		path: "/screens",
		name: ScreenRouteNameEnum.list,
		component: () => import("@/pages/screens/ScreensListPage.vue"),
		meta: {
			title: ScreenRouteNameEnum.list,
			layout: "MainLayout",
			authRequired: true,
			permission: AppPermissions.CanViewOwnScreens,
		},
	},
	{
		path: "/screens/create",
		name: ScreenRouteNameEnum.create,
		component: () => import("@/pages/screens/ScreensCreatePage.vue"),
		meta: {
			title: ScreenRouteNameEnum.create,
			layout: "MainLayout",
			authRequired: true,
			permission: AppPermissions.CanCreatePlace,
		},
	},
];
